import get from 'lodash/get';
import { push } from 'connected-react-router';
import { getCurrentBreadcrumb } from '../redux/reducers/helper';
import { PAGE_ACTIVITY_LOGGER } from '../redux/types';
import SessionStorageServices from './sessionStorageServices';
import { isCustomRole } from '../utils';

export const pageRouter = (dispatch, route) => {
  dispatch(push(`/${route}`));
};

export default function router(dispatch, uid, cjEventId, response) {
  const currentStatus = get(response, 'data.response.other_params.current_status', '');
  const breadcrumbs = get(response, 'data.response.breadcrumbs', []);
  const currentBreadcrumb = getCurrentBreadcrumb(breadcrumbs);
  const pageActivityLogger = ['completed', 'signature'];
  const role = get(response, 'data.response.other_params.role', '');

  const redirectUrl = get(response, 'data.response.other_params.next_button_redirect_url', false);
  if (pageActivityLogger.indexOf(currentStatus) > -1) {
    dispatch({
      type: PAGE_ACTIVITY_LOGGER,
      params: { currentStatus },
    });
    if (redirectUrl) {
      window.location.replace(redirectUrl);
    }
  }

  // Processing screen redirection
  if (currentStatus === 'processing') {
    if (redirectUrl) {
      setTimeout(() => {
        window.location.replace(redirectUrl);
      }, 5000);
    }
  }

  const path = window.location.pathname;

  if (path.includes('accident')) {
    dispatch(push(`${path}`));
    return;
  }

  const roleString = isCustomRole(role) ? '&role=csr' : '';
  const utmQueryString = SessionStorageServices.getLocalValue('utm_query_string');
  const utmTagsQueryString =
    utmQueryString && currentStatus === 'quote' ? `&${utmQueryString}` : '';

  if (currentStatus === 'questions') {
    dispatch(push(`/questions/${currentBreadcrumb.id}?uid=${uid}${roleString}`));
  } else if (uid) {
    dispatch(push(`/${currentStatus}?uid=${uid}${roleString}${utmTagsQueryString}`));
  } else {
    dispatch(push(`/${currentStatus}`));
  }
}
